import { render, staticRenderFns } from "./CoreAppBarNotifications.vue?vue&type=template&id=09728aa6"
import script from "./CoreAppBarNotifications.vue?vue&type=script&lang=js"
export * from "./CoreAppBarNotifications.vue?vue&type=script&lang=js"
import style0 from "./CoreAppBarNotifications.vue?vue&type=style&index=0&id=09728aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports